/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespCollectionsComponents_shippingFilters$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsModules_shippingFilters$ref: FragmentReference;
export type SbRespCollectionsModules_shippingFilters = $ReadOnlyArray<{|
  +$fragmentRefs: SbRespCollectionsComponents_shippingFilters$ref,
  +$refType: SbRespCollectionsModules_shippingFilters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_shippingFilters",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7eec9dee98bd0402f377d170e195f69a';
module.exports = node;
